import MemberRequest from "../../../../Controllers/MemberRequest";

function getResult(data) {
  let res=false;
  if (data.hasOwnProperty("getOstanData")) {
    res = data.getOstanData;
    if(res=== null) res=false;
  }
  return res;
}

const sendGet = async function (pageAlerts) {
  let res=false;
  let req=new MemberRequest();
  req._pageAlerts=pageAlerts;
  req.query='{getOstanData{ostan{id,name}}}';
  res = await req.send(getResult);
  return res;
};

export default async function getOstanDataApi(pageAlerts) {
  return await sendGet(pageAlerts);
}
